// GFrPA8GdcOIE99I2

import React, { useState } from "react";
import MyNavbar from "../components/MyNavbar";

export default function LoginSignup() {
    const [isSignup, setIsSignup] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        password: "",
    });

    const toggleForm = () => setIsSignup(!isSignup);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(isSignup ? "Signup Data: " : "Login Data: ", formData);
        // Add your form submission logic here
    };

    return (
      <>
      <MyNavbar></MyNavbar>
        <div className="container d-flex align-items-center justify-content-center vh-100">
            <div className="card shadow-lg p-4" style={{ maxWidth: "400px", width: "100%" }}>
                <h2 className="text-center mb-4">{isSignup ? "Sign Up" : "Log In"}</h2>
                <form onSubmit={handleSubmit}>
                    {isSignup && (
                        <div className="mb-3">
                            <label htmlFor="name" className="form-label">Full Name</label>
                            <input
                                type="text"
                                className="form-control"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter your full name"
                                required
                            />
                        </div>
                    )}
                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">Email Address</label>
                        <input
                            type="email"
                            className="form-control"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Enter your email"
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="password" className="form-label">Password</label>
                        <input
                            type="password"
                            className="form-control"
                            id="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            placeholder="Enter your password"
                            required
                        />
                    </div>
                    <button type="submit" className="btn btn-primary w-100">
                        {isSignup ? "Sign Up" : "Log In"}
                    </button>
                </form>
                <div className="text-center mt-3">
                    <small>
                        {isSignup ? "Already have an account? " : "Don't have an account? "}
                        <button
                            className="btn btn-link p-0"
                            onClick={toggleForm}
                        >
                            {isSignup ? "Log In" : "Sign Up"}
                        </button>
                    </small>
                </div>
            </div>
        </div>
      </>
    );
}
